const cleanSurvey = (survey) => {
  const { checkedIds, dueDate, template, name, notes, round, status, constraints } = survey;

  const filteredUsersList = [];

  for (let i = 0; i < checkedIds.length; i++) {
    filteredUsersList.push({ _id: checkedIds[i] });
  }

  const payload = {
    users: filteredUsersList,
    notes,
    round,
    template,
    name,
    dueDate,
    status,
    constraints
  };

  return payload;
};

export default cleanSurvey;
